import * as _ from 'lodash';

import {
    IWeeklySchedulerOptions, WeeklySchedulerRange
} from '@captiveaire/weeklyscheduler';

import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';
import { DynamicSlotEditorComponent } from '../dynamic-slot-editor/dynamic-slot-editor.component';
import { IDeviceInputComponent } from '../device-input/device-input.interface';
import { IDynamicCalendar } from '../shared/models/device';
import { DynamicModelWeeklySchedulerAdapter } from './dynamic-calendar-weekly-scheduler-adapter';
import { DynamicModelWeeklySchedulerItem } from './dynamic-calendar-weekly-scheduler-item';
import { DynamicDTO } from './dynamic-dto.interface';

@Component({
    selector: 'dl-dynamic-calendar',
    templateUrl: './dynamic-calendar.component.html'
})
export class DynamicCalendarComponent implements IDeviceInputComponent, OnInit {
    public static $name: string = 'dynamicCalendar';

    constructor(
        private dialogService: MatDialog,
        private themeService: ThemeService
    ) {
    }

    @Input() public deviceInput: IDynamicCalendar;
    @Input() public deviceInputForm: FormGroup;
    public hasDeviceInput: boolean = true;

    adapter: DynamicModelWeeklySchedulerAdapter;

    isReady: boolean = false;

    weeklySchedulerOptions: IWeeklySchedulerOptions<any>;

    headerClass: string;

    private days: string[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    private theme: string;

    public ngOnInit() {
        this.theme = this.themeService.getTheme();
        this.headerClass = this.themeService.getTextAccentClass();

        this.weeklySchedulerOptions = {
            appearanceOptions: {
                buttonRowHeight: (config) => '46px',
                rowHeight: (config) => '28px',
            },
            buttonClasses: ['md-button', 'md-accent', 'md-raised', `md-${this.theme}-theme`],
            createItem: (day, schedules) => {
                return new DynamicModelWeeklySchedulerItem(day, schedules);
            },
            editSlot: (schedule: WeeklySchedulerRange<any>) => {
                const dialogRef = this.dialogService.open(DynamicSlotEditorComponent, {
                    data: {
                        nullEnds: this.deviceInput.nullEnds,
                        schedule: schedule,
                        weeklySchedulerOptions: this.weeklySchedulerOptions
                    }
                });

                return dialogRef.afterClosed()
                    .toPromise()
                    .then(result => {
                        if (result) {
                            schedule.$isDeleting = result.delete;
                            schedule.start = result.start;
                            schedule.end = result.end;
                            this.refreshViewModel();
                        }

                        return schedule;
                    }).catch(reason => {
                        throw reason;
                    });
            },
            interval: this.deviceInput.interval,
            fullCalendar: this.deviceInput.fullCalendar,
            nullEnds: this.deviceInput.nullEnds,
            onChange: (form) => this.refreshViewModel(form),
            onRemove: () => this.refreshViewModel(),
            scheduleCountOptions: {
                count: this.determineScheduleCount(this.deviceInput),
                exact: this.deviceInput.isScheduleCountExact
            }
        };

        if (this.deviceInput.maxValue) {
            this.weeklySchedulerOptions.maxValue = this.deviceInput.maxValue;
        }

        this.adapter = new DynamicModelWeeklySchedulerAdapter(this.deviceInput);

        this.isReady = true;
    }

    private determineScheduleCount(item: IDynamicCalendar) {
        // Still slightly hacky.
        return item[this.days[0]].items.length;
    }

    private refreshViewModel(form?: any) {
        let formGroup = form as FormGroup;

        if (this.deviceInputForm) {
            if (formGroup) {
                let key = 'calendarInvalid' + _.uniqueId();
                this.deviceInputForm.setErrors({[key]: formGroup.valid ? null : true});
            }
            this.deviceInputForm.markAsDirty();
            this.deviceInputForm.updateValueAndValidity();
        }

        // This is also a little hacky but gets the job done...
        let snapshot = this.adapter.getSnapshot();

        let snapshotByDay: _.Dictionary<DynamicDTO[]> = _.groupBy(snapshot, schedule => schedule.day);

        for (let key in snapshotByDay) {
            let itemKey = this.days[key];
            let data = snapshotByDay[key];
            let len = data.length;

            let currentItem = this.deviceInput[itemKey];

            for (let i = 0; i < len; i++) {
                if (currentItem.items[i]) {
                    let currentDailySchedule = currentItem.items[i].value;

                    currentDailySchedule.isVisible = true;
                    currentDailySchedule.startTime.value = data[i].start;
                    currentDailySchedule.endTime.value = data[i].end;
                }
            }
        }
    }
}
